import React from 'react';
import styled from 'styled-components';

import { Button } from 'src/presentation/components/agent_desktop_components';
import CopyableValue from 'src/presentation/components/pages/email/components/CopyableValue';
import FieldContainer from 'src/presentation/components/forms/FieldContainer';
import { Row } from 'src/presentation/components/forms/Layout';
import { StyledBody } from 'src/presentation/components/forms/Body';
import StyledFooter from 'src/presentation/components/forms/Footer';

const ViewChannelIntegrationDataForm = ({ item, onClose }) => {
  return (
    <>
      <StyledBody>
        <Row>
          <FieldContainer
            label="Channel ID"
            description="The ID that represents the custom channel"
            control={<StyledCopyableValue className="copyableValue" value={item?.configuration?.customChannelId} />}
          />
        </Row>
        <Row>
          <FieldContainer
            label="Entry Point Address"
            description="The receiving address of an inbound message"
            control={<StyledCopyableValue className="copyableValue" value={item?.configuration?.recipientAddress} />}
          />
        </Row>
      </StyledBody>
      <StyledFooter>
        <Button data-aid="modalClose" onClick={onClose}>
          Done
        </Button>
      </StyledFooter>
    </>
  );
};

const StyledCopyableValue = styled(CopyableValue)`
  min-width: 405px;
`;

export default ViewChannelIntegrationDataForm;
